<template>
  <div class="container">
    <div class="myPrize-container">
      <div class="myPrize-section">
        <header class="myPrize-header">
          <p class="myPrize-header-title">兑换历史</p>
          <router-link :to="{ name: 'redeem_the_prize_list' }"
            ><el-button size="mini" type="warning" class="myPrize-header-button"
              >返回</el-button
            ></router-link
          >
        </header>
        <div class="myPrize-body">
          <template>
            <el-table
              border
              :data="HistoryGiftsData"
              style="width: 100%"
              v-loading="loading"
            >
              <el-table-column
                prop="gift_name"
                label="我的奖品"
                :show-overflow-tooltip="true"
                width="160"
              >
                <template slot-scope="scope">
                  <div>
                    {{ (scope.row.gift || {}).name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="数量" width="60">
              </el-table-column>
              <el-table-column prop="unit_integral" label="使用积分" width="80">
              </el-table-column>
              <el-table-column prop="created_at" label="创建时间" width="180">
              </el-table-column>
              <el-table-column
                label="审核状态"
                width="80"
                prop="examine_status_label"
              >
              </el-table-column>
              <el-table-column
                prop="delivery_status_label"
                label="发货状态"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="address" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click="handleWatchExpress(scope.row.express)"
                    >查看物流</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="total"
            @current-change="editCurrentPage"
          >
          </el-pagination>
          <el-dialog
            :visible.sync="expressDialog"
            width="480px"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <div class="dialog-form">
              <div class="form-item">
                <p class="label">物流公司：</p>
                <p class="content">
                  {{ expressInfo.express_company || "暂无数据" }}
                </p>
              </div>
              <div class="form-item">
                <p class="label">物流单号：</p>
                <p class="content">
                  {{ expressInfo.express_number || "暂无数据" }}
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import giftService from "@/global/service/gift";
export default {
  data() {
    return {
      HistoryGiftsData: [],
      pageSize: 10,
      pageCount: null,
      total: null,
      currentPage: 1,
      loading: false,
      expressDialog: false,
      expressInfo: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleWatchExpress(info) {
      this.expressInfo = info || {};
      this.expressDialog = true;
    },
    editCurrentPage(index) {
      this.currentPage = index;
      this.getData();
    },
    handleClose() {
      this.expressDialog = false;
      // this.expressInfo = {};
    },
    getData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      giftService
        .myGiftList(params)
        .then(res => {
          this.HistoryGiftsData = res.list;
          this.total = res.pagination.total;
          this.currentPage = res.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.myPrize-section {
  background-color: #fff;
  .myPrize-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #dedede;
    font-size: 12px;
    color: #2c3e50;
    font-weight: 300;
    .el-button {
      background-color: #fff;
      color: #f0b32f;
    }
  }
  .myPrize-body {
    padding: 20px;
  }
  .dialog-form {
    padding-left: 50px;
    .form-item {
      display: flex;
      margin-bottom: 10px;
      .label {
        font-size: 14px;
        color: #606266;
        width: 100px;
        text-align: right;
      }
      .content {
        font-size: 14px;
        color: #606266;
        text-align: left;
      }
    }
  }
}
</style>
